import store from "@/store/auth";

class Auth {
  login(username, password) {
    return new Promise(resolve => {
      let url = process.env.VUE_APP_API + "login/";

      let data = {
        username: username,
        password: password
      };

      fetch(url, {
        method: "post",
        body: JSON.stringify(data)
      }).then(response => {
        if (response.status === 200) {
          response.json().then(json => {
            if (json.token !== false) {
              store.dispatch("setJwt", json.token).catch(err => {
                console.error(err);
                resolve(false);
              });
              resolve(json);
            } else {
              resolve(false);
            }
          });
        } else if (response.status === 401) {
          resolve(false);
        }
      });
    });
  }

  isUserManager() {
    let userRole = store.getters.getRole;
    return userRole === "admin" || userRole === "manage";
  }

  isUserAdmin() {
    let userRole = store.getters.getRole;
    return userRole === "admin";
  }
}

export default new Auth();
